// Percentile mapping for Solidarity Index scores (0-100 scale)
export const PERCENTILE_MAPPING = [
  {
    "score": "0–19",
    "percentile": null,
    "text": "Patříte k desetině lidí, kteří svým chováním a postoji vykazují nejnižší index solidarity."
  },
  { "score": 20, "percentile": 12 },
  { "score": 21, "percentile": 14 },
  { "score": 22, "percentile": 15 },
  { "score": 23, "percentile": 18 },
  { "score": 24, "percentile": 20 },
  { "score": 25, "percentile": 23 },
  { "score": 26, "percentile": 25 },
  { "score": 27, "percentile": 27 },
  { "score": 28, "percentile": 29 },
  { "score": 29, "percentile": 30 },
  { "score": 30, "percentile": 34 },
  { "score": 31, "percentile": 35 },
  { "score": 32, "percentile": 38 },
  { "score": 33, "percentile": 40 },
  { "score": 34, "percentile": 43 },
  { "score": 35, "percentile": 45 },
  { "score": 36, "percentile": 47 },
  { "score": 37, "percentile": 51 },
  { "score": 38, "percentile": 54 },
  { "score": 39, "percentile": 55 },
  { "score": 40, "percentile": 58 },
  { "score": 41, "percentile": 61 },
  { "score": 42, "percentile": 62 },
  { "score": 43, "percentile": 64 },
  { "score": 44, "percentile": 66 },
  { "score": 45, "percentile": 68 },
  { "score": 46, "percentile": 70 },
  { "score": 47, "percentile": 72 },
  { "score": 48, "percentile": 74 },
  { "score": 49, "percentile": 75 },
  { "score": 50, "percentile": 76 },
  { "score": 51, "percentile": 77 },
  { "score": 52, "percentile": 79 },
  { "score": 53, "percentile": 81 },
  { "score": 54, "percentile": 82 },
  { "score": 55, "percentile": 83 },
  { "score": 56, "percentile": 84 },
  { "score": 57, "percentile": 85 },
  { "score": 58, "percentile": 87 },
  { "score": 59, "percentile": 88 },
  { "score": 60, "percentile": 90 },
  { "score": 61, "percentile": 90 },
  { "score": 62, "percentile": 91 },
  { "score": 63, "percentile": 92 },
  { "score": 64, "percentile": 92 },
  { "score": 65, "percentile": 93 },
  { "score": 66, "percentile": 94 },
  { "score": 67, "percentile": 94 },
  { "score": 68, "percentile": 94 },
  { "score": 69, "percentile": 95 },
  { "score": 70, "percentile": 96 },
  { "score": 71, "percentile": 96 },
  { "score": 72, "percentile": 97 },
  { "score": 73, "percentile": 97 },
  { "score": 74, "percentile": 97 },
  { "score": 75, "percentile": 98 },
  { "score": 76, "percentile": 98 },
  { "score": 77, "percentile": 98 },
  { "score": 78, "percentile": 99 },
  { "score": 79, "percentile": 99 },
  { "score": 80, "percentile": 99 },
  { "score": 81, "percentile": 99 },
  { "score": 82, "percentile": 99 },
  { "score": 83, "percentile": 99 },
  { "score": 84, "percentile": 100 },
  {
    "score": "85–100",
    "percentile": 100
  }
];

// Helper function to get percentile for a given score
export const getPercentileForScore = (score: number): { percentile: number | null, text: string } => {
  // Handle special cases
  if (score <= 19) {
    return {
      percentile: null,
      text: "Patříte k desetině lidí, kteří svým chováním a postoji vykazují nejnižší index solidarity."
    };
  }
  
  if (score >= 85) {
    return {
      percentile: 100,
      text: `Hodnota Vašeho osobního indexu solidarity je ${score}. To odpovídá 100. percentilu v české společnosti. Jinými slovy, jste v nejsolidárnější skupině lidí.`
    };
  }

  // Find exact match
  const exactMatch = PERCENTILE_MAPPING.find(item => 
    typeof item.score === 'number' && item.score === score
  );
  
  if (exactMatch && exactMatch.percentile !== null) {
    return {
      percentile: exactMatch.percentile,
      text: `Hodnota Vašeho osobního indexu solidarity je ${score}. To odpovídá ${exactMatch.percentile}. percentilu v české společnosti. Jinými slovy, asi ${exactMatch.percentile - 1} % lidí má nižší hodnotu indexu solidarity než Vy.`
    };
  }

  // Fallback - find closest lower score
  let closestMatch = null;
  for (const item of PERCENTILE_MAPPING) {
    if (typeof item.score === 'number' && item.score <= score && item.percentile !== null) {
      if (!closestMatch || item.score > closestMatch.score) {
        closestMatch = item;
      }
    }
  }

  if (closestMatch && closestMatch.percentile !== null) {
    return {
      percentile: closestMatch.percentile,
      text: `Hodnota Vašeho osobního indexu solidarity je ${score}. To odpovídá ${closestMatch.percentile}. percentilu v české společnosti. Jinými slovy, asi ${closestMatch.percentile - 1} % lidí má nižší hodnotu indexu solidarity než Vy.`
    };
  }

  // Final fallback
  return {
    percentile: 50,
    text: `Hodnota Vašeho osobního indexu solidarity je ${score}. To odpovídá 50. percentilu v české společnosti. Jinými slovy, asi 49 % lidí má nižší hodnotu indexu solidarity než Vy.`
  };
};